import { defineStore } from 'pinia'
import { delClips } from '~/apis/app'
import { useMySongsStore } from '~/stores/mySongsStore'

type CancelHandler = (() => void | Promise<void>) | null

export const useUploadModalStore = defineStore('uploadModalStore', () => {
  const open = ref(false)
  const status = ref('Preparing audio...')
  const progress = ref(0)
  const cancelHandler = ref<CancelHandler>(null)
  const taskUuid = ref('')
  const deleting = ref(false)

  const show = (payload: { status?: string, progress?: number, onCancel?: () => void }) => {
    status.value = payload.status ?? 'Preparing audio...'
    progress.value = Math.min(100, Math.max(0, Math.round(payload.progress ?? 0)))
    cancelHandler.value = payload.onCancel ?? null
    open.value = true
  }

  const setStatus = (value: string) => {
    status.value = value
  }

  const setProgress = (value: number) => {
    progress.value = Math.min(100, Math.max(0, Math.round(value)))
  }

  const close = () => {
    open.value = false
    status.value = 'Preparing audio...'
    progress.value = 0
    cancelHandler.value = null
    taskUuid.value = ''
  }

  const setTaskUuid = (value?: string | null) => {
    taskUuid.value = value ?? ''
  }

  const deleteByUuid = async () => {
    if (!taskUuid.value || deleting.value) return
    deleting.value = true
    try {
      await delClips({
        isDelete: '1',
        uuids: taskUuid.value
      }, {
        showSuccess: false,
        loading: false
      })
      useMySongsStore().triggerRefresh()
    } catch (error) {
      console.warn('Failed to delete upload task:', error)
    } finally {
      taskUuid.value = ''
      deleting.value = false
    }
  }

  const cancel = async () => {
    if (cancelHandler.value) {
      await cancelHandler.value()
    }
    if (taskUuid.value) {
      await deleteByUuid()
    }
    close()
  }

  return {
    open,
    status,
    progress,
    taskUuid,
    show,
    setStatus,
    setProgress,
    close,
    cancel,
    setTaskUuid
  }
})

